import { queryOptions, useQuery } from '@tanstack/react-query';

import type { ForumPost } from './types';

import { apiResourceSchema } from '../common/schemas';
import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { findDataInQueryCache } from '../utils';
import { forumPostSchema } from './schemas';

export const forumPostQueryOptions = (id: number) => {
  const cachedForumPost = findDataInQueryCache<ForumPost>(QueryKeys.forum.index.root, (post) => post.id === id);

  return queryOptions({
    queryKey: QueryKeys.forum.show.id(id),
    queryFn: async () => {
      const { data: forumPost } = await fetchJson(`/forum/posts/${id}`, {
        schema: apiResourceSchema(forumPostSchema),
      });

      return forumPost;
    },
    initialData: cachedForumPost?.data,
    initialDataUpdatedAt: cachedForumPost?.state.dataUpdatedAt,
    staleTime: 60 * 1000,
  });
};

export const useForumPost = (id: number) => {
  return useQuery(forumPostQueryOptions(id));
};
